import React from 'react';

const Separator = () => {
  return (
    <div className='h-[3px] w-full bg-mOrange'></div>
  );
}

export default Separator;
